import BrandPage from "./components/BrandPage";

function App() {
  return <BrandPage />;
}

export default App;
